import { render } from "./TeacherSubject.vue?vue&type=template&id=5b17d47e&scoped=true"
import script from "./TeacherSubject.vue?vue&type=script&lang=js"
export * from "./TeacherSubject.vue?vue&type=script&lang=js"

import "./TeacherSubject.vue?vue&type=style&index=0&id=5b17d47e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b17d47e"]])

export default __exports__